import { put } from 'redux-saga/effects';

export default function* initialise() {

    console.log(`match`);

    yield console.log(`Loaded...`);
}
